export class Header {
    listenMenu: MenuSection = new MenuSection();
    respondMenu: MenuSection = new MenuSection();
    analyseMenu: MenuSection = new MenuSection();
    adminMenu: MenuSection = new MenuSection();
    notificationMenu: MenuSection = new MenuSection();
    otherActionsMenu: MenuSection = new MenuSection();
    accountMenu: MenuSection = new MenuSection();
    teamMoodAdminMenu: MenuSection = new MenuSection();
    callToActionMenu: CallToActionMenu;
    firstname: string;
    lastname: string;
    unreadFeedItemsCount: number;
}

export class TopMenu {
    teamMoodAdminMenu: MenuEntry[];
    personalSettingsMenu: HeaderMenuEntry[];
    accountMenu: HeaderMenuEntry[];
    unread_feed_items_count: number;
    helpMenu: HeaderMenuEntry[];
    callToActionMenu: CallToActionMenu;
}
export class SideMenu {
    listenMenu: MenuSection;
    respondMenu: MenuSection;
    analyseMenu: MenuSection;
    adminMenu: MenuSection;
}

export class MenuSection {
    name: string;
    items: MenuEntry[] = [];
}

export interface MenuEntry {
    name: string;
    linkType: "link" | "button";
    icon: string;
    description: string;
    stateName: string;
    teamId?: string;
    parent?: string;
    counter?: number;
}

export interface HeaderMenuEntry {
    linkType: "link" | "text" | "separator" | "helplink"
    name?: string;
    icon?: string;
    description?: string;
    iconDesc?: string;
    stateName?: string;
    url?: string;
}

interface CallToActionMenu {
    name: string;
    linkType: "link" | "button";
    stateName?: string;
    trial_count: Number;
    teamId?: string;
}

export interface FeedItem {
    title: string;
    details: string;
    time: string;
    link: string;
    read: boolean;
    anchor?: string;
    click(): void;
}

